var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"belts-hero"},[_c('div',{staticClass:"belts-hero-text"},[_c('h1',[_vm._v("Leather Belts")]),_c('p',[_vm._v(" Discover timelass leather belts crafted for everyday style, comfort, and lasting quality. ")])]),_c('div',{staticClass:"belts-hero-image"},[_c('img',{attrs:{"src":require("../assets/Blushbelt.jpg"),"alt":"Leather Belts"}})])])
}]

export { render, staticRenderFns }